import React from 'react';
import styled from 'styled-components';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { propValidationConfig } from './propValidationConfig';
export const NumberInCircle = ({
  count,
  size = 'large',
  inverted,
  className
}) => {
  return /*#__PURE__*/React.createElement(StyledNumber, {
    $size: size,
    $inverted: inverted,
    className: className
  }, count);
};
const StyledNumber = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "NumberInCircle__StyledNumber",
  componentId: "sc-jruj3c-0"
})(["width:", ";height:", ";border-radius:50%;font-weight:700;display:flex;justify-content:center;align-items:center;color:", ";border:1px solid ", ";"], ({
  $size
}) => $size === 'small' ? spacing.space24 : spacing.space40, ({
  $size
}) => $size === 'small' ? spacing.space24 : spacing.space40, ({
  $inverted
}) => $inverted ? nafColor.signature.white : nafColor.signature.black, ({
  $inverted
}) => $inverted ? nafColor.signature.white : nafColor.signature.black);
//# sourceMappingURL=NumberInCircle.js.map